import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonNb from './locales/nb/common.json';
import commonSv from './locales/sv/common.json';
import commonEn from './locales/en/common.json';

export const SPRAK = ['nb', 'sv', 'en'] as const;
export type Sprak = (typeof SPRAK)[number];

const LAGRET_SPRAK = 'onboard.sprak';

export const ressurser = {
  nb: { common: commonNb },
  sv: { common: commonSv },
  en: { common: commonEn },
};

/** Lagret valg først, så nettleserens språk (no og nn blir nb), ellers nb. */
export function startsprak(): Sprak {
  const lagret = lesLagret();
  if (lagret && (SPRAK as readonly string[]).includes(lagret)) return lagret as Sprak;

  const nettleser = (navigator.language || '').toLowerCase().split('-')[0];
  if (['nb', 'no', 'nn'].includes(nettleser)) return 'nb';
  if (nettleser === 'sv') return 'sv';
  if (nettleser === 'en') return 'en';
  return 'nb';
}

/** Har brukeren valgt språk selv på denne enheten? Da går valget foran språket reisen er laget med. */
export function harLagretSprak(): boolean {
  return lesLagret() !== null;
}

export function byttSprak(sprak: Sprak) {
  try {
    localStorage.setItem(LAGRET_SPRAK, sprak);
  } catch {
    // Privat modus eller blokkert lagring: valget gjelder bare denne økten
  }
  return i18n.changeLanguage(sprak);
}

function lesLagret(): string | null {
  try {
    return localStorage.getItem(LAGRET_SPRAK);
  } catch {
    return null;
  }
}

i18n.on('languageChanged', (sprak) => {
  document.documentElement.lang = sprak;
});

i18n.use(initReactI18next).init({
  resources: ressurser,
  lng: startsprak(),
  fallbackLng: 'nb',
  supportedLngs: SPRAK,
  defaultNS: 'common',
  ns: ['common'],
  interpolation: { escapeValue: false },
  initImmediate: false,
});

export default i18n;
